import { CnpjMask } from './CnpjMask';
import { CpfMask } from './CpfMask';

const checkLengthToMaskCpfOrCnpj = (doc: string): string => {
  if (doc?.length > 11) {
    return CnpjMask(doc);
  } else {
    return CpfMask(doc);
  }
};

export { checkLengthToMaskCpfOrCnpj };
